// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"jd","modalBox":"jd","modal-mask":"je","modalMask":"je","close-btn":"jf","closeBtn":"jf","container":"jg","content":"jh","title":"ji","subTitle":"jj","detail":"jk"};